import { CustomError } from 'ts-custom-error';
export class IntegrationError extends CustomError {
    constructor(message, code, status) {
        super(message);
        this.status = status;
        this.code = code;
    }
}
export class RetryableError extends CustomError {
    constructor(message = '', status = 500) {
        super(message);
        this.code = ErrorCodes.RETRYABLE_ERROR;
        this.status = status;
    }
}
export class InvalidAuthenticationError extends CustomError {
    constructor(message = '', code = ErrorCodes.INVALID_AUTHENTICATION) {
        super(message);
        this.status = 401;
        this.code = code;
    }
}
export class PayloadValidationError extends IntegrationError {
    constructor(message) {
        super(message, ErrorCodes.PAYLOAD_VALIDATION_FAILED, 400);
    }
}
export class APIError extends IntegrationError {
    constructor(message, status) {
        super(message, status.toString(), status);
    }
}
export class SelfTimeoutError extends IntegrationError {
    constructor(message) {
        super(message, ErrorCodes.SELF_TIMEOUT, 408);
    }
}
export var HttpErrorCodes;
(function (HttpErrorCodes) {
    HttpErrorCodes["CONTINUE"] = "CONTINUE";
    HttpErrorCodes["SWITCHING_PROTOCOLS"] = "SWITCHING_PROTOCOLS";
    HttpErrorCodes["PROCESSING"] = "PROCESSING";
    HttpErrorCodes["EARLY_HINTS"] = "EARLY_HINTS";
    HttpErrorCodes["OK"] = "OK";
    HttpErrorCodes["CREATED"] = "CREATED";
    HttpErrorCodes["ACCEPTED"] = "ACCEPTED";
    HttpErrorCodes["NON_AUTHORITATIVE_INFORMATION"] = "NON_AUTHORITATIVE_INFORMATION";
    HttpErrorCodes["NO_CONTENT"] = "NO_CONTENT";
    HttpErrorCodes["RESET_CONTENT"] = "RESET_CONTENT";
    HttpErrorCodes["PARTIAL_CONTENT"] = "PARTIAL_CONTENT";
    HttpErrorCodes["MULTI_STATUS"] = "MULTI_STATUS";
    HttpErrorCodes["ALREADY_REPORTED"] = "ALREADY_REPORTED";
    HttpErrorCodes["IM_USED"] = "IM_USED";
    HttpErrorCodes["MULTIPLE_CHOICES"] = "MULTIPLE_CHOICES";
    HttpErrorCodes["MOVED_PERMENANTLY"] = "MOVED_PERMENANTLY";
    HttpErrorCodes["FOUND"] = "FOUND";
    HttpErrorCodes["SEE_OTHER"] = "SEE_OTHER";
    HttpErrorCodes["NOT_MODIFIED"] = "NOT_MODIFIED";
    HttpErrorCodes["USE_PROXY"] = "USE_PROXY";
    HttpErrorCodes["SWITCH_PROXY"] = "SWITCH_PROXY";
    HttpErrorCodes["TEMPORARY_REDIRECT"] = "TEMPORARY_REDIRECT";
    HttpErrorCodes["PERMANENT_REDIRECT"] = "PERMANENT_REDIRECT";
    HttpErrorCodes["BAD_REQUEST"] = "BAD_REQUEST";
    HttpErrorCodes["UNAUTHORIZED"] = "UNAUTHORIZED";
    HttpErrorCodes["PAYMENT_REQUIRED"] = "PAYMENT_REQUIRED";
    HttpErrorCodes["FORBIDDEN"] = "FORBIDDEN";
    HttpErrorCodes["NOT_FOUND"] = "NOT_FOUND";
    HttpErrorCodes["METHOD_NOT_ALLOWED"] = "METHOD_NOT_ALLOWED";
    HttpErrorCodes["NOT_ACCEPTABLE"] = "NOT_ACCEPTABLE";
    HttpErrorCodes["PROXY_AUTHENTICATION_REQUIRED"] = "PROXY_AUTHENTICATION_REQUIRED";
    HttpErrorCodes["REQUEST_TIMEOUT"] = "REQUEST_TIMEOUT";
    HttpErrorCodes["CONFLICT"] = "CONFLICT";
    HttpErrorCodes["GONE"] = "GONE";
    HttpErrorCodes["LENGTH_REQUIRED"] = "LENGTH_REQUIRED";
    HttpErrorCodes["PRECONDITION_FAILED"] = "PRECONDITION_FAILED";
    HttpErrorCodes["PAYLOAD_TOO_LARGE"] = "PAYLOAD_TOO_LARGE";
    HttpErrorCodes["URI_TOO_LONG"] = "URI_TOO_LONG";
    HttpErrorCodes["UNSUPPORTED_MEDIA_TYPE"] = "UNSUPPORTED_MEDIA_TYPE";
    HttpErrorCodes["RANGE_NOT_SATISFIABLE"] = "RANGE_NOT_SATISFIABLE";
    HttpErrorCodes["EXPECTATION_FAILED"] = "EXPECTATION_FAILED";
    HttpErrorCodes["IM_A_TEAPOT"] = "IM_A_TEAPOT";
    HttpErrorCodes["MISDIRECTED_REQUEST"] = "MISDIRECTED_REQUEST";
    HttpErrorCodes["UNPROCESSABLE_ENTITY"] = "UNPROCESSABLE_ENTITY";
    HttpErrorCodes["LOCKED"] = "LOCKED";
    HttpErrorCodes["FAILED_DEPENDENCY"] = "FAILED_DEPENDENCY";
    HttpErrorCodes["TOO_EARLY"] = "TOO_EARLY";
    HttpErrorCodes["UPGRADE_REQUIRED"] = "UPGRADE_REQUIRED";
    HttpErrorCodes["PRECONDITION_REQUIRED"] = "PRECONDITION_REQUIRED";
    HttpErrorCodes["TOO_MANY_REQUESTS"] = "TOO_MANY_REQUESTS";
    HttpErrorCodes["REQUEST_HEADER_FIELDS_TOO_LARGE"] = "REQUEST_HEADER_FIELDS_TOO_LARGE";
    HttpErrorCodes["UNAVAILABLE_FOR_LEGAL_REASONS"] = "UNAVAILABLE_FOR_LEGAL_REASONS";
    HttpErrorCodes["INTERNAL_SERVER_ERROR"] = "INTERNAL_SERVER_ERROR";
    HttpErrorCodes["NOT_IMPLEMENTED"] = "NOT_IMPLEMENTED";
    HttpErrorCodes["BAD_GATEWAY"] = "BAD_GATEWAY";
    HttpErrorCodes["SERVICE_UNAVAILABLE"] = "SERVICE_UNAVAILABLE";
    HttpErrorCodes["GATEWAY_TIMEOUT"] = "GATEWAY_TIMEOUT";
    HttpErrorCodes["HTTP_VERSION_NOT_SUPPORTED"] = "HTTP_VERSION_NOT_SUPPORTED";
    HttpErrorCodes["VARIANT_ALSO_NEGOTIATES"] = "VARIANT_ALSO_NEGOTIATES";
    HttpErrorCodes["INSUFFICIENT_STORAGE"] = "INSUFFICIENT_STORAGE";
    HttpErrorCodes["LOOP_DETECTED"] = "LOOP_DETECTED";
    HttpErrorCodes["BANDWIDTH_LIMIT_EXCEEDED"] = "BANDWIDTH_LIMIT_EXCEEDED";
    HttpErrorCodes["NOT_EXTENDED"] = "NOT_EXTENDED";
    HttpErrorCodes["NETWORK_AUTHENTICATION_REQUIRED"] = "NETWORK_AUTHENTICATION_REQUIRED";
    HttpErrorCodes["SITE_IS_OVERLOADED"] = "SITE_IS_OVERLOADED";
})(HttpErrorCodes || (HttpErrorCodes = {}));
export var CustomErrorCodes;
(function (CustomErrorCodes) {
    CustomErrorCodes["INVALID_AUTHENTICATION"] = "INVALID_AUTHENTICATION";
    CustomErrorCodes["PAYLOAD_VALIDATION_FAILED"] = "PAYLOAD_VALIDATION_FAILED";
    CustomErrorCodes["INVALID_CURRENCY_CODE"] = "INVALID_CURRENCY_CODE";
    CustomErrorCodes["RETRYABLE_ERROR"] = "RETRYABLE_ERROR";
    CustomErrorCodes["REFRESH_TOKEN_EXPIRED"] = "REFRESH_TOKEN_EXPIRED";
    CustomErrorCodes["OAUTH_REFRESH_FAILED"] = "OAUTH_REFRESH_FAILED";
    CustomErrorCodes["SELF_TIMEOUT"] = "SELF_TIMEOUT";
    CustomErrorCodes["UNKNOWN_ERROR"] = "UNKNOWN_ERROR";
})(CustomErrorCodes || (CustomErrorCodes = {}));
const HTTP_ERROR_CODE_MAP = {
    100: HttpErrorCodes.CONTINUE,
    101: HttpErrorCodes.SWITCHING_PROTOCOLS,
    102: HttpErrorCodes.PROCESSING,
    103: HttpErrorCodes.EARLY_HINTS,
    200: HttpErrorCodes.OK,
    201: HttpErrorCodes.CREATED,
    202: HttpErrorCodes.ACCEPTED,
    203: HttpErrorCodes.NON_AUTHORITATIVE_INFORMATION,
    204: HttpErrorCodes.NO_CONTENT,
    205: HttpErrorCodes.RESET_CONTENT,
    206: HttpErrorCodes.PARTIAL_CONTENT,
    207: HttpErrorCodes.MULTI_STATUS,
    208: HttpErrorCodes.ALREADY_REPORTED,
    226: HttpErrorCodes.IM_USED,
    300: HttpErrorCodes.MULTIPLE_CHOICES,
    301: HttpErrorCodes.MOVED_PERMENANTLY,
    302: HttpErrorCodes.FOUND,
    303: HttpErrorCodes.SEE_OTHER,
    304: HttpErrorCodes.NOT_MODIFIED,
    305: HttpErrorCodes.USE_PROXY,
    306: HttpErrorCodes.SWITCH_PROXY,
    307: HttpErrorCodes.TEMPORARY_REDIRECT,
    308: HttpErrorCodes.PERMANENT_REDIRECT,
    400: HttpErrorCodes.BAD_REQUEST,
    401: HttpErrorCodes.UNAUTHORIZED,
    402: HttpErrorCodes.PAYMENT_REQUIRED,
    403: HttpErrorCodes.FORBIDDEN,
    404: HttpErrorCodes.NOT_FOUND,
    405: HttpErrorCodes.METHOD_NOT_ALLOWED,
    406: HttpErrorCodes.NOT_ACCEPTABLE,
    407: HttpErrorCodes.PROXY_AUTHENTICATION_REQUIRED,
    408: HttpErrorCodes.REQUEST_TIMEOUT,
    409: HttpErrorCodes.CONFLICT,
    410: HttpErrorCodes.GONE,
    411: HttpErrorCodes.LENGTH_REQUIRED,
    412: HttpErrorCodes.PRECONDITION_FAILED,
    413: HttpErrorCodes.PAYLOAD_TOO_LARGE,
    414: HttpErrorCodes.URI_TOO_LONG,
    415: HttpErrorCodes.UNSUPPORTED_MEDIA_TYPE,
    416: HttpErrorCodes.RANGE_NOT_SATISFIABLE,
    417: HttpErrorCodes.EXPECTATION_FAILED,
    418: HttpErrorCodes.IM_A_TEAPOT,
    421: HttpErrorCodes.MISDIRECTED_REQUEST,
    422: HttpErrorCodes.UNPROCESSABLE_ENTITY,
    423: HttpErrorCodes.LOCKED,
    424: HttpErrorCodes.FAILED_DEPENDENCY,
    425: HttpErrorCodes.TOO_EARLY,
    426: HttpErrorCodes.UPGRADE_REQUIRED,
    428: HttpErrorCodes.PRECONDITION_REQUIRED,
    429: HttpErrorCodes.TOO_MANY_REQUESTS,
    431: HttpErrorCodes.REQUEST_HEADER_FIELDS_TOO_LARGE,
    451: HttpErrorCodes.UNAVAILABLE_FOR_LEGAL_REASONS,
    500: HttpErrorCodes.INTERNAL_SERVER_ERROR,
    501: HttpErrorCodes.NOT_IMPLEMENTED,
    502: HttpErrorCodes.BAD_GATEWAY,
    503: HttpErrorCodes.SERVICE_UNAVAILABLE,
    504: HttpErrorCodes.GATEWAY_TIMEOUT,
    505: HttpErrorCodes.HTTP_VERSION_NOT_SUPPORTED,
    506: HttpErrorCodes.VARIANT_ALSO_NEGOTIATES,
    507: HttpErrorCodes.INSUFFICIENT_STORAGE,
    508: HttpErrorCodes.LOOP_DETECTED,
    509: HttpErrorCodes.BANDWIDTH_LIMIT_EXCEEDED,
    510: HttpErrorCodes.NOT_EXTENDED,
    511: HttpErrorCodes.NETWORK_AUTHENTICATION_REQUIRED,
    529: HttpErrorCodes.SITE_IS_OVERLOADED
};
export const ErrorCodes = {
    ...HttpErrorCodes,
    ...CustomErrorCodes
};
export function getErrorCodeFromHttpStatus(status) {
    return HTTP_ERROR_CODE_MAP[status] || ErrorCodes.UNKNOWN_ERROR;
}
export var MultiStatusErrorReporter;
(function (MultiStatusErrorReporter) {
    MultiStatusErrorReporter["INTEGRATIONS"] = "INTEGRATIONS";
    MultiStatusErrorReporter["DESTINATION"] = "DESTINATION";
})(MultiStatusErrorReporter || (MultiStatusErrorReporter = {}));
//# sourceMappingURL=errors.js.map